import React from 'react';
import FacebookContentGenerator from './FacebookContentGenerator';

const Lemon8ContentGenerator = () => {
  return <FacebookContentGenerator platform="lemon8" />;
};

export default Lemon8ContentGenerator;

